import useSWRImmutable from 'swr/immutable';

import { ComponentService } from 'services/ComponentService';

const useDistributors = () => {
    const swr = useSWRImmutable('/components/distributors', ComponentService.getDistributors);

    return {
        ...swr,
        distributors: swr.data ?? [],
    };
};

export { useDistributors };
